module.exports = __webpack_public_path__ + "img/Logo all white.87d15f7d.png";